import { c as _c } from "react/compiler-runtime";
import { Button, Card, Heading, HStack, Icon, Separator, SimpleGrid, Text, VStack, Wrap } from '@chakra-ui/react';
import { DIR_CATEGORIES } from '@src/components/sco/Advisors/data/dirCategories';
import { useIsMobile } from '@src/components/sco/Advisors/hooks/useIsMobile';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { SectionScroll } from '@src/components/sco/Advisors/shared/SectionScroll';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { LuArrowRight, LuUsers } from 'react-icons/lu';

/**
 * Topic discovery surface — large category tiles.
 * Selecting a topic navigates to `/advisors/directory` with that category filter.
 */
export const BrowseSection = () => {
  const $ = _c(15);
  const paths = useAdvisorsPaths();
  const isMobile = useIsMobile();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading size="2xl">Browse by topic</Heading>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isMobile ? "sm" : "md";
  let t2;
  if ($[1] !== t1) {
    t2 = <VStack align="stretch" gap={1}>{t0}<Text color="colorPalette.fg/60" fontSize={t1}>Pick a specialty area to see approved advisors who can help. You can also search all advisors by keyword.</Text></VStack>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon boxSize={4}><LuUsers /></Icon>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== paths.directory) {
    t4 = <HStack justify="flex-start"><Button asChild={true} size="sm" variant="outline"><NextLink href={paths.directory}>{t3}View all advisors</NextLink></Button></HStack>;
    $[4] = paths.directory;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: 1,
      sm: 2,
      lg: 2
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== paths.directory) {
    t6 = DIR_CATEGORIES.map(cat => <Card.Root key={cat.key} asChild={true} overflow="hidden" variant="interactive"><NextLink href={`${paths.directory}?category=${encodeURIComponent(cat.key)}`}><Card.Body gap={4}><HStack align="center" gap={2}><Icon boxSize={5} color={`${cat.palette}.fg`}><cat.icon /></Icon><Heading size="lg">{cat.name}</Heading></HStack><Text color="colorPalette.fg/60" fontFamily="longform" fontSize="lg">{cat.value}</Text><Wrap gap={1}>{cat.chips.map(chip => <SpecialtyTag key={chip} colorPalette={cat.palette} label={chip} />)}</Wrap><Separator marginY={2} /><HStack fontSize="sm" fontWeight="semibold" justify="flex-end"><Text>See advisors</Text><Icon boxSize={4}><LuArrowRight /></Icon></HStack></Card.Body></NextLink></Card.Root>);
    $[7] = paths.directory;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <SimpleGrid columns={t5} gap={6}>{t6}</SimpleGrid>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t7) {
    t8 = <SectionScroll>{t2}{t4}{t7}</SectionScroll>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};